export default {
  api: {
    list: {
      method: "get",
      url: "/user/coupon/list"
    },
    getCouponRange: {
      method: "get",
      url: "/user/coupon/range/{productId}"
    }
  }
};
